import React, { useEffect, useState } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import { useLang, tx } from '../i18n/LanguageContext';
import { editorExtensions } from './editor/extensions';
import { EditorToolbar } from './editor/EditorToolbar';
import { toEditorHtml } from '../lib/richText';

export const RichTextEditor = ({ value, onChange, dir = 'rtl', placeholder, testId, minHeight = 120, stickyTop = 0 }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const [source, setSource] = useState(false);
  const editor = useEditor({
    extensions: editorExtensions,
    textDirection: dir,
    content: toEditorHtml(value),
    onUpdate: ({ editor: ed }) => onChange(ed.isEmpty ? '' : ed.getHTML()),
    editorProps: { attributes: { class: 'rich-content tiptap-editor px-4 py-3 outline-none text-sm text-slate-800', style: `min-height:${minHeight}px` } },
  });

  useEffect(() => {
    if (editor && !editor.isFocused && toEditorHtml(value) !== (editor.isEmpty ? '' : editor.getHTML())) editor.commands.setContent(toEditorHtml(value), { emitUpdate: false });
  }, [value, editor]);

  if (!editor) return null;
  return (
    <div data-testid={testId} className="rounded-xl border border-slate-200 bg-white focus-within:border-blue-500 focus-within:ring-4 focus-within:ring-blue-100 transition-[border-color,box-shadow]">
      <div className="sticky z-10 rounded-t-xl overflow-hidden bg-white" style={{ top: stickyTop }}>
        <EditorToolbar editor={editor} L={L} testId={testId} source={source} setSource={setSource} />
      </div>
      {source ? (
        <textarea dir="ltr" value={value} onChange={(e) => { onChange(e.target.value); editor.commands.setContent(e.target.value, { emitUpdate: false }); }}
          style={{ minHeight }} className="w-full px-4 py-3 font-mono text-xs outline-none resize-y" data-testid={`${testId}-source-textarea`} />
      ) : (
        <div className="relative">
          {editor.isEmpty && <div className="absolute top-3 inset-x-4 text-sm text-slate-400 pointer-events-none" dir={dir}>{placeholder}</div>}
          <EditorContent editor={editor} />
        </div>
      )}
    </div>
  );
};
